import axios from '@/utils/api'

export const getGeorreferenciamentoData = async (protocol, loader = true) => {
  try {
    const result = await axios({
      method: 'GET',
      url: `/georreferenciamento/${protocol}/praticas`,
      loader
    })

    return result
  } catch (error) {
    handleError(error)
  }
}

export const saveGeorreferenciamento = async (protocol, data) => {
  const formatPayload = (payload) => {
    return Object.values(payload).map((pratica) => {
      return {
        id: pratica.id,
        layers: pratica.layers,
        vectorizedArea: pratica.vectorizedArea
      }
    })
  }

  try {
    const result = await axios({
      method: 'POST',
      url: `georreferenciamento/${protocol}/praticas/cadastrar`,
      data: formatPayload(data)
    })

    return result.data
  } catch (error) {
    handleError(error)
  }
}

export const deleteGeorreferenciamentoPratica = async (protocol, tipo) => {
  try {
    const result = await axios({
      method: 'DELETE',
      url: `georreferenciamento/${protocol}/praticas/${tipo}`
    })

    return result.data
  } catch (error) {
    handleError(error)
  }
}

/**
 * Função para tratar mensagens de erro se necessário
 * @param {Object} error
 */
const handleError = (error) => {
  throw new Error(error.response.data.message)
}



// WEBPACK FOOTER //
// ./src/services/georreferenciamento/index.js